import { Controller } from "stimulus"
import notify from "../../packs/notify"
import axios from "axios";
import i18next from "i18next";
export default class extends Controller {
  static targets = ["paymentBalance", "paymentAmount", "clientReference", "submitButton"]

  connect(){
    this.initValidation()
  }

  initValidation(){
    $(this.element).validate( {
      ignore: [],
      errorPlacement: function(error, element) {
        element.parent().append(error);
      }
    })

    $(this.clientReferenceTarget).rules('add', {
      maxlength: this.clientReferenceValidationRules.maxlength
    })
  }

  makePayment(event){
    event.preventDefault();
    if(!$(this.element).valid()) return

    let ticket = this.element.querySelector('input#TICKET')
    let ticketName = this.element.querySelector('input#TICKET_NAME')
    let amount = this.element.querySelector('input#TOUCHNET_AMOUNT')

    this.submitButtonTarget.disabled = true
    axios({
      url: '/touchnet/generate_token.json', 
      method: 'POST',
      data: {
        amount: this.paymentAmountTarget.value, 
        client_reference: this.clientReferenceTarget.value
      }
    })
    .then(response =>{
      if(response.data.status == 'success'){
        ticket.value = response.data.ticket
        ticketName.value = response.data.ticket_name
        amount.value = response.data.amount
        this.element.submit()
      }
    })
    .catch(({response})=>{
      if(response.status == 422){
        notify({message: response.data.message, status: response.data.status, parentElement: this.pageAlertElement})
      }else{
        notify({message: i18next.t('An error occured while processing payment! Your account has not been charged.'), status: 'error', parentElement: this.pageAlertElement})
      }
    }).finally(()=>{
      this.submitButtonTarget.disabled = true
    })
  }

  get pageAlertElement(){
    return document.getElementById('page-alert')
  }

  get clientReferenceValidationRules(){
    if(!this.clientReferenceTarget.dataset.validationRules) throw 'Provide client refrence validation'
    
    return JSON.parse(this.clientReferenceTarget.dataset.validationRules)
  }
}